import { useState } from "react";
import { PAGE_NUMBER, PAGE_SIZE } from "../../utils/constants";
import { useGetStudentsWithDuplicatedSchoolCodesQuery } from "../../hooks/useGetStudentsWithDuplicatedSchoolCodesQuery";
import TableComponent from "../../components/common/Tables";
import { Card, Flex } from "@radix-ui/themes";
import { Lists } from "../../components/common/Lists";

const columnNamesMap: { [key: string]: string } = {
   schoolCode: 'Código do estudante',
   fullname: 'Estudante',
  };
  
export const DuplicatedSchoolCodes = () => { 
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
      const { data, status } = useGetStudentsWithDuplicatedSchoolCodesQuery({ PageNumber: currentPage, PageSize: pageSize });
      const handlePageChange = (page: number) => {
          setCurrentPage(page);
      };
      const handlePageSizeChange = (size: number) => {
          setPageSize(size);
          setCurrentPage(PAGE_NUMBER);
      };
      return (
        <Card>
            <Flex gap="4" direction="column">
                <Lists
                    status={status}
                    TableComponent={() =>
                        <TableComponent
                            columns={Object.keys(columnNamesMap)}
                            items={data?.items}
                            options={[]}
                            columnNamesMap={columnNamesMap}
                            totalPages={data?.totalPages || 1}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            pageSize={pageSize}
                            onPageSizeChange={handlePageSizeChange}
                            totalItems={data?.totalItems}
                        />
                    }
                    handleClickCreate={undefined}
                />
            
            </Flex>
        </Card>
    )
 }